import React, { useEffect, useState } from 'react';

const WindyEffect = () => {
    const [leaves, setLeaves] = useState([]);

    useEffect(() => {
        // Generate wind particles (leaves)
        const particles = [];
        const count = 40; // Number of leaves

        const leafTypes = ['🍂', '🍁', '🍃'];

        for (let i = 0; i < count; i++) {
            particles.push({
                id: i,
                left: Math.random() * 100, // Random horizontal position (%)
                top: -10 - Math.random() * 20, // Start above viewport
                animationDuration: 8 + Math.random() * 8, // Float duration (8-16s)
                animationDelay: Math.random() * 5, // Start delay (0-5s)
                size: 15 + Math.random() * 15, // Size (15-30px)
                rotation: Math.random() * 360, // Initial rotation
                leaf: leafTypes[Math.floor(Math.random() * leafTypes.length)], // Random leaf type
            });
        }

        setLeaves(particles);
    }, []);

    return (
        <div className="windy-container">
            {leaves.map((leaf) => (
                <div
                    key={leaf.id}
                    className="wind-leaf"
                    style={{
                        left: `${leaf.left}%`,
                        top: `${leaf.top}%`,
                        fontSize: `${leaf.size}px`,
                        animationDuration: `${leaf.animationDuration}s`,
                        animationDelay: `${leaf.animationDelay}s`,
                        transform: `rotate(${leaf.rotation}deg)`,
                    }}
                >
                    {leaf.leaf}
                </div>
            ))}

            {/* Wind lines for effect */}
            <div className="wind-lines">
                {[...Array(5)].map((_, i) => (
                    <div key={i} className="wind-line" style={{ animationDelay: `${i * 0.3}s` }} />
                ))}
            </div>
        </div>
    );
};

export default WindyEffect;
